import React from "react";
import * as SC from "./PrintPostEditorLinkedInFeed.styled.js";

import { useTranslation } from "react-i18next";

import logger from "../../../../../../utils/LoggerFrontend";
import { ButtonOutlinedAnchor } from "../../../../Previews/Components/Buttons";
import PrintCampaignCreateTeaserEditor from "../../print-campaign-create-teaser-editor/PrintCampaignCreateTeaserEditor";
import PrintCampaignCreateChannelDataEditor from "../../print-channel-editor/PrintCampaignCreateChannelDataEditor";

import { Tooltip } from "../../../../../../Components/Overlays";
import { channelsByShortName } from "../../../../../../data/app__channels";
import PrintTemplateEditor from "../../print-campaign-template-editor/PrintTemplateEditor.jsx";

export const PageHeader = ({
  pageLogo,
  pageName,
  pageId,
  pageNameColor,
  sponsoredMessageColor,
  sponsoredLogo
}) => {
  const { t } = useTranslation();

  logger.debug("PostEditorLinkedInFeed:PageHeader:render", "renders", { pageId });
  return (
    <SC.PageHeaderWrapper>
      <SC.PageLogo src={pageLogo} alt="" />
      <div>
        <SC.PageName color={pageNameColor}>{pageName}</SC.PageName>
        <SC.SponsoredMessage color={sponsoredMessageColor}>
          {t("Sponsored")}
          {sponsoredLogo && (
            <Tooltip label={t("Playout as sponsored advertisement")} bgColor="#1C1928">
              <SC.SponsoredLogo src="/images/sponsored_icon.svg" alt="" />
            </Tooltip>
          )}
        </SC.SponsoredMessage>
      </div>
    </SC.PageHeaderWrapper>
  );
};

const PrintPostEditorLinkedInFeed = ({
  postData,
  channel,
  channelData,
  mobile,
  editable,
  selectedCreativeIndexToEdit,
  mediaAssetsProps,
  mediaAssets,
  imageDimensions
}) => {
  const { t } = useTranslation();
  logger.debug("PostEditorLinkedInFeed:render", "render:", {
    postData,
    channelData,
    mobile,
    editable,
    imageDimensions
  });

  const templatePreviewSizes = {
    minHeight: SC.LINKEDINFEED_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].minHeight,
    maxHeight: SC.LINKEDINFEED_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].maxHeight,
    width: SC.LINKEDINFEED_IMAGE_SIZE_SPEC[mobile ? "mobile" : "web"].pictureWidth,
    minAspect: channelsByShortName["linkedin-feed"].minAspect,
    maxAspect: channelsByShortName["linkedin-feed"].maxAspect
  };

  return (
    <SC.PostEditorLinkedInFeedWrapper mobile={mobile}>
      {mobile && <SC.MobileTop src="/images/mobile-top.png" alt="" />}
      <div style={{ display: "flex" }}>
        {mobile && <SC.MobileSide src="/images/mobile-left.png" alt="" />}
        <SC.LinkedInFeedEditorWrapper mobile={mobile}>
          <SC.LinkedInFeedEditor mobile={mobile}>
            <SC.Header>
              <PageHeader
                pageLogo={"/images/linkedin.png"}
                pageName={"LinkedIn Feed"}
                pageId={channelData?.pageId}
                sponsoredLogo
              />
            </SC.Header>
            <SC.EditorWrapper>
              <PrintCampaignCreateTeaserEditor
                channel="linkedin-feed"
                teaserText={postData.teaserText}
                editable={editable}
                teaserTextStyle={SC.teaserTextStyle}
                smallButtons={mobile}
                disableEmojis={true}
                limit={600}
              />
            </SC.EditorWrapper>
            <SC.PhotoEditorWrapper>
              <PrintTemplateEditor
                mediaAssets={mediaAssets}
                mediaAssetsProps={mediaAssetsProps}
                selectedMediaAssetIndexToEdit={selectedCreativeIndexToEdit}
                templatePreviewSizes={templatePreviewSizes}
                channel={channel}
              />

              <Tooltip label={t("LinkedInFeed display image")} bgColor="#1C1928">
                <SC.LinkedInFeedInfoLogo src="/images/facebook_info_icon.svg" alt="" />
              </Tooltip>
            </SC.PhotoEditorWrapper>
            <SC.FooterWrapper>
              <SC.FooterTextSections>
                <PrintCampaignCreateChannelDataEditor
                  tooltip={t("Displayed link")}
                  value={channelData.displayLink}
                  dataKey="displayLink"
                  textStyle={SC.displayLinkStyle}
                  limit={channelsByShortName["linkedin-feed"].limits.displayLink}
                  label={t("Displayed link")}
                  bannedCharaters={["!", "?"]}
                  editable={editable}
                  urlValue={channelData.url}
                />
                <PrintCampaignCreateChannelDataEditor
                  tooltip={t("Job Title")}
                  value={channelData.title}
                  dataKey="title"
                  textStyle={SC.titleStyle}
                  limit={channelsByShortName["linkedin-feed"].limits.title}
                  label={t("Job Title")}
                  editable={editable}
                />

                <PrintCampaignCreateChannelDataEditor
                  tooltip={t("Subtitle")}
                  value={channelData.subHeadline}
                  dataKey="subHeadline"
                  textStyle={SC.subHeadlineStyle}
                  limit={channelsByShortName["linkedin-feed"].limits.subHeadline}
                  label={t("Subtitle")}
                  editable={editable}
                />
              </SC.FooterTextSections>
              <ButtonOutlinedAnchor target="_blank" href={channelData?.url || "#"}>
                {t("Read more")}
              </ButtonOutlinedAnchor>
            </SC.FooterWrapper>
          </SC.LinkedInFeedEditor>
        </SC.LinkedInFeedEditorWrapper>
        {mobile && <SC.MobileSide src="/images/mobile-right.png" alt="" />}
      </div>
      {mobile && <SC.MobileBottom src="/images/mobile-bottom.png" alt="" />}
    </SC.PostEditorLinkedInFeedWrapper>
  );
};

export default PrintPostEditorLinkedInFeed;
